import { Component } from '@angular/core';
import { DetectPlatformService } from '../../../services/detectPlatform.service';

@Component({
  selector: 'landing-hero-section',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
})
export class LandingHeroSectionComponent {
  constructor(public detectPlatformService: DetectPlatformService) {}

  onLinkClicked() {
    window.scrollTo(0, 0);
  }
}
